<template>
  <div class="device-binding-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-container">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备 SN 绑定</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" header="📝 填写绑定信息">
      <el-form :model="bindingForm" :rules="Rules" ref="bindingForm" label-width="150px">

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备类型" prop="productId">
              <el-select v-model="bindingForm.productId" placeholder="请选择要绑定的设备类型" style="width: 100%;">
                <el-option label="消防吊桶" value="2"></el-option>
                <el-option label="清洗喷枪" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">设备 SN 详情</el-divider>

        <el-row :gutter="20" v-if="bindingForm.productId === '2'">
          <el-col :span="12">
            <el-form-item label="UDID">
              <el-input
                v-model="searchUdid"
                placeholder="请输入 UDID（可输入尾部）"
                clearable
              >
                <el-button
                  slot="append"
                  icon="el-icon-refresh"
                  @click="searchByUdid"
                  :loading="loading"
                >
                  查询
                </el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 查询结果列表 -->
        <el-row v-if="udidSnList.length > 0">
          <el-col :span="24">
            <el-form-item label="查询结果">
              <el-radio-group v-model="selectedItem">
                <el-radio
                  v-for="item in udidSnList"
                  :key="item.udid"
                  :label="item"
                >
                  UDID：{{ item.udid }} ｜ SN：{{ item.sn }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 显示选中项 -->
        <el-row v-if="selectedItem">
          <el-col :span="24">
            <el-alert
              type="success"
              :closable="false"
              show-icon
            >
              已选择：UDID {{ selectedItem.udid }} ，SN {{ selectedItem.sn }}
            </el-alert>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-else-if="bindingForm.productId === '1'">
          <el-col :span="8">
            <el-form-item label="遥控器SN" prop="sn1">
              <el-input v-model="bindingForm.sn1" placeholder="请输入遥控器SN"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="飞机SN" prop="sn2">
              <el-input v-model="bindingForm.sn2" placeholder="请输入飞机SN"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="水枪SN" prop="sn3">
              <el-input v-model="bindingForm.sn3" placeholder="请输入水枪SN"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item style="margin-top: 30px;">
          <el-button
            type="primary"
            :icon="isEditMode ? 'el-icon-check' : 'el-icon-upload'"
            @click="submitBinding"
          >
            {{ isEditMode ? '保存修改' : '立即绑定' }}
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetForm">
            {{ isEditMode ? '撤销修改' : '重置' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from '../../utils/request'

export default {
  name: 'DeviceBindingForm',
  // 接收路由参数 (例如从列表页跳转过来时携带的 ID)
  // props: {
  //   deviceId: {
  //     type: [String, Number],
  //     default: null
  //   }
  // },
  data () {
    var validatesn11 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('天空端sn不能为空'))
      } else {
      // if (localStorage.getItem('sn11') === value) {
      //   if (localStorage.getItem('message11') === 'sn已在库中') {
      //     callback(new Error('sn已在库中'))
      //   } else {
      //     callback()
      //   }
      // } else {
        axios.get(`/data/bind/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn已在库中') {
            localStorage.setItem('sn11', value)
            localStorage.setItem('message11', 'sn已在库中')
            callback(new Error(res.data))
          } else {
            callback()
            // localStorage.setItem('sn11', value)
            // localStorage.setItem('message11', '')
          }
        })
      }
    }

    var validateudid = (rule, value, callback) => {
      if (!value) {
        callback(new Error('duid不能为空'))
      } else {
      // if (localStorage.getItem('udid') === value) {
      //   if (localStorage.getItem('messageudid') === 'sn已在库中') {
      //     callback(new Error('sn已在库中'))
      //   } else {
      //     callback()
      //   }
      // } else {
        axios.get(`/data/bind/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn已在库中') {
            // localStorage.setItem('udid', value)
            // localStorage.setItem('messageudid', 'sn已在库中')
            callback(new Error(res.data))
          } else {
            callback()
            // localStorage.setItem('udid', value)
            // localStorage.setItem('messageudid', '')
          }
        })
      }
    }
    var validatesn1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('飞机sn不能为空'))
      } else {
      // if (localStorage.getItem('sn1') === value) {
      //   if (localStorage.getItem('messagesn1') === 'sn已在库中') {
      //     callback(new Error('sn已在库中'))
      //   } else {
      //     callback()
      //   }
      // } else {
        axios.get(`/data/bind/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn已在库中') {
            // localStorage.setItem('sn1', value)
            // localStorage.setItem('messagesn1', 'sn已在库中')
            callback(new Error(res.data))
          } else {
            callback()
            // localStorage.setItem('sn1', value)
            // localStorage.setItem('messagesn1', '')
          }
        })
      }
    }
    var validatesn2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('遥控器sn不能为空'))
      } else {
        // if (localStorage.getItem('sn2') === value) {
        //   if (localStorage.getItem('messagesn2') === 'sn已在库中') {
        //     callback(new Error('sn已在库中'))
        //   } else {
        //     callback()
        //   }
        // } else {
        axios.get(`/data/bind/validatesn?sn=${value}`).then(res => {
          console.log('message', res)
          if (res.data === 'sn已在库中') {
            // localStorage.setItem('sn2', value)
            // localStorage.setItem('messagesn2', 'sn已在库中')
            callback(new Error(res.data))
          } else {
            callback()
            // localStorage.setItem('sn2', value)
            // localStorage.setItem('messagesn2', '')
          }
        })
      }
    }
    return {
      // 新增状态：判断是绑定（新增）还是编辑（修改）
      isEditMode: false,
      bindingForm: {
        id: 0,
        productId: '1',
        sn11: '',
        udid: '',
        sn1: '',
        sn2: '',
        sn3: ''
      },
      searchUdid: '',
      udidSnList: [],
      selectedItem: null,
      loading: false,
      Rules: {
        sn11: [{ required: true, validator: validatesn11, trigger: 'blur' }],
        udid: [{ required: true, validator: validateudid, trigger: 'blur' }],
        sn1: [{ required: true, validator: validatesn1, trigger: 'blur' }],
        sn2: [{ required: true, validator: validatesn2, trigger: 'blur' }]
        // sn3: [
        //   { validator: validatesn3, trigger: 'blur' }
        // ]
      }
      // ... bindingRules 保持不变
    }
  },
  // watch: {
  //   // 监听 deviceId 变化，用于组件复用时的加载
  //   deviceId: {
  //     immediate: true,
  //     handler (newId) {
  //       if (newId) {
  //         this.isEditMode = true
  //         this.fetchDeviceDetail(newId)
  //       } else {
  //         this.isEditMode = false
  //         this.resetForm()
  //       }
  //     }
  //   }
  // },
  mounted () {
    this.isEditMode = this.$route.query.isEditMode
    this.bindingForm.id = this.$route.query.deviceId
    if (this.$route.query.productId) {
      this.bindingForm.productId = this.$route.query.productId
    } else {
      this.bindingForm.productId = '1'
    }
    this.bindingForm.sn11 = this.$route.query.sn11
    this.bindingForm.udid = this.$route.query.udid
    this.bindingForm.sn1 = this.$route.query.sn1
    this.bindingForm.sn2 = this.$route.query.sn2
    this.bindingForm.sn3 = this.$route.query.sn3
    console.log('isEditMode', this.isEditMode)
    console.log('id', this.bindingForm.deviceId)
  },
  methods: {
    async searchByUdid () {
      if (!this.searchUdid) {
        this.$message.warning('请输入 UDID')
        return
      }

      this.loading = true
      this.selectedItem = null
      this.udidSnList = []

      try {
        const res = await axios.get('/data/bind/queryByUdid', {
          params: {
            udid: this.searchUdid
          }
        })

        // 假设后端返回：
        // [{ udid: 'xxx', sn: 'yyy' }]
        this.udidSnList = res.data || []

        if (this.udidSnList.length === 0) {
          this.$message.info('未查询到匹配设备')
        }
      } catch (e) {
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    // 1. 获取设备详情（用于编辑模式）
    fetchDeviceDetail (id) {
      // this.$message.info(`TODO: 调用 API 获取设备 ID: ${id} 详情...`)
      this.bindingForm = {
        productId: this.$route.query.productId, // 假设查到的是消防吊桶
        sn11: this.$route.query.sn11,
        udid: this.$route.query.udid,
        sn1: this.$route.query.sn1,
        sn2: this.$route.query.sn2,
        sn3: this.$route.query.sn3,
        id: id
      }
    },

    submitBinding () {
      if (this.bindingForm.productId === '2') {
        if (!this.selectedItem) {
          this.$message.error('请选择一个 UDID 和 SN')
          return
        }

        // 赋值给真正提交字段
        this.bindingForm.udid = this.selectedItem.udid
        this.bindingForm.sn11 = this.selectedItem.sn
      }
      if (this.isEditMode) {
        axios.post('/data/bind/update', this.bindingForm).then(res => {
          this.$message.success('绑定成功')
          this.$router.push('/device/list')
        })
      } else {
        this.$refs.bindingForm.validate(async (valid) => {
          if (!valid) return
          axios.post('/data/bind/insert', this.bindingForm).then(res => {
            this.$message.success('绑定成功')
            this.$router.push('/device/list')
          })
        })
      }
    },
    // 3. 重置表单
    resetForm () {
      // 如果处于编辑模式，应该重新加载详情，而不是清空
      if (this.isEditMode) {
        this.fetchDeviceDetail(this.bindingForm.deviceId)
      } else {
        if (this.bindingForm.productId === '1') {
          this.bindingForm = {
            productId: '1', // 假设查到的是消防吊桶
            sn11: '',
            udid: '',
            sn1: '',
            sn2: '',
            sn3: ''
            // id: id
          }
        } else if (this.bindingForm.productId === '2') {
          this.bindingForm = {
            productId: '2', // 假设查到的是消防吊桶
            sn11: '',
            udid: '',
            sn1: '',
            sn2: '',
            sn3: ''
            // id: id
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .breadcrumb-container {
    margin-bottom: 20px;
  }
  .box-card {
    max-width: 1000px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DeviceBindingForm.vue